export const FDA_MESSAGES = {
    LOAD_ERROR: 'Failed to load inspection data.',
    RECORDS_LOAD_FAILURE: 'Could not load records',
    NO_RECORDS_FOUND: 'No inspection records found for this company',
    NO_RECORDS_DESCRIPTION: 'There are no published FDA inspection records available for this company.',
    TIMEOUT_ERROR: 'FDA API request timed out. Please try again.',
    API_ERROR: (status: number, statusText: string) => `FDA API returned ${status}: ${statusText}`,
    OUTCOME_LABELS: {
        'NAI': 'No significant compliance issues identified',
        'VAI': 'Voluntary Action Indicated (minor issues)',
        'OAI': 'Official Action Indicated (serious issues)'
    } as Record<string, string>,
    LOADING: 'Loading inspection data...',
    DISCLAIMER: 'FDA Form 483s are issued at the facility level. Observations apply only to the inspected site and do not necessarily reflect other facilities operated by the same company.',
};
